import React from 'react';

export function AudioFile () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="48"
      fill="none"
      viewBox="0 0 41 48"
    >
      <path
        fill="#B4DCD9"
        d="M1 11.454L11.263 1H38a2 2 0 012 2v42a2 2 0 01-2 2H3a2 2 0 01-2-2V11.454z"
      />
      <path fill="#94CAC5" d="M20.5 1l-9.237 9.711V1H20.5z" />
      <path
        stroke="#4AA49D"
        strokeLinejoin="round"
        strokeWidth="0.5"
        d="M1 11.454L11.263 1H38a2 2 0 012 2v42a2 2 0 01-2 2H3a2 2 0 01-2-2V11.454z"
      />
      <path
        fill="#CFEDEB"
        stroke="#4AA49D"
        strokeLinejoin="round"
        strokeWidth="0.5"
        d="M1 11.222L11.263 1v9.222a1 1 0 01-1 1H1z"
      />
      <path
        fill="#94CAC5"
        stroke="#4AA49D"
        strokeLinejoin="round"
        strokeWidth="0.5"
        d="M29.28 19.284l-13.187 3.51V37.1c0 1.515-2.176 2.744-4.216 2.744S8.184 38.615 8.184 37.1c0-1.516 1.654-2.745 3.694-2.745a4.69 4.69 0 011.846.367v-15.68a1 1 0 01.733-.964l16.065-4.46a1 1 0 011.268.964V33.44c0 1.516-2.316 2.745-4.356 2.745s-3.694-1.23-3.694-2.745c0-1.516 1.654-2.745 3.694-2.745.672 0 1.303.133 1.846.367V19.284z"
      />
    </svg>
  );
}
